<script>
export default {
  name: 'Expired',
}
</script>

<template>
  <v-container
    class="text-center"
    fill-height
    style="height: calc(100vh - 58px);"
  >
    <v-row align="center">
      <v-col>
        <p class="font-weight-bold">
          {{ $t("pages.expired.headline") }}
        </p>
        <p>{{ $t("pages.expired.body") }}</p>
        <v-btn
          v-if="false"
          to="/"
          color="primary"
          text
        >
          {{ $t("pages.expired.btn") }}
        </v-btn>
      </v-col>
    </v-row>
  </v-container>
</template>
